// TODO : refactor - mix between filter and/or column types ?

export const COLUMN_TYPE = {
    arbitrary: 'arbitrary',
    enum: 'enum',
    dateTime: 'dateTime',
    location: 'location',
    duration: 'duration',
    number: 'number',
    searchableEnum: 'searchableEnum'
};

export const COLUMN_DEFAULT_VALUES = {
    arbitrary: '',
    enum: '',
    dateTime: 0,
    location: { latitude: 0, longitude: 0 },
    duration: 0,
    number: 0
};

export function isDateTimeColumn(type) {
    return type === COLUMN_TYPE.dateTime;
}

export function isLocationColumn(type) {
    return type === COLUMN_TYPE.location;
}

export function isColumnFilterable(type) {
    return type && type !== COLUMN_TYPE.location;
}

export function isEnumColumn(type) {
    return type && (type === COLUMN_TYPE.searchableEnum || type === COLUMN_TYPE.enum);
}
